export default __webpack_public_path__ + "static/media/slide7.3bc3f895.png";